import React from 'react'

import { TextColorType } from '@ui/design-system/colors/colors'
import { IconFCType, IconProps } from '@ui/icons/types'

export type IconRendererType =
  | IconFCType
  | { icon: IconFCType; color: TextColorType; secondaryColor?: TextColorType }

interface Props extends Pick<IconProps, 'size'> {
  icon: IconRendererType
  size: number
  currentColor?: boolean
}

export const IconRenderer: React.FC<Props> = (props) => {
  const { icon, size } = props

  const isIconObject = typeof icon === 'object' && icon !== null && 'icon' in icon

  const IconComponent = isIconObject ? icon?.icon : icon
  const iconColor = isIconObject ? icon?.color : 'currentColor'
  const secondaryColor = isIconObject ? icon?.secondaryColor : undefined

  return <IconComponent color={iconColor} secondaryColor={secondaryColor} size={size} />
}
